<template>
    <div class="container-fluid p-3">
        <div class="d-flex flex-row justify-content-between">
            <div class="d-flex flex-column">
                <div class="title d-flex align-items-center">
                    <inline-svg class="me-2" width="36" height="36" src="/assets/img/icons/face-smile.svg"></inline-svg>
                    Heroes
                </div>
                <div class="subtitle">See and manage your Heroes | <strong>Each Hero needs a MagnusCards account</strong></div>
            </div>
            <div class="d-flex flex-column">
                <btn class="btn btn-primary" @click="$modal.show('addHeroModal')">
                    <inline-svg class="me-1" src="/assets/img/icons/plus.svg"></inline-svg>
                    Add a Hero
                </btn>
            </div>
        </div>
        <div class="mt-3">
            <heroes-table></heroes-table>
        </div>
        <modal name="addHeroModal" height="auto" width="500px" :scrollable="true" @before-open="clearInput">
            <div class="modal-content">
                <div class="modal-header d-flex flex-column">
                    <div class="w-100 text-center" style="position: relative">
                        <h4 class="modal-title">Add a Hero</h4>
                        <button type="button" class="btn-close btn-close-absolute" data-dismiss="modal" aria-hidden="true"
                                @click="$modal.hide('addHeroModal')"></button>
                    </div>
                    <div class="modal-subtitle-gray">Add the details required bellow.</div>
                </div>
                <div class="modal-body">
                    <div class="modal-body" v-if="step === 1">
                        <form-group label="Hero's name*">
                            <form-input inputClass="form-control-lg" placeholder="Ex: John Smith"
                                        v-model="add_hero.name" :v="$v.add_hero.name"/>
                        </form-group>
                        <div class="my-2 form-group d-flex flex-column align-items-center justify-content-center">
                            <div class="mb-2">Avatar photo</div>
                            <profile-image-uploader :is_user_profile="true" image_type="user" :editable="true" v-model="add_hero.profile_image"></profile-image-uploader>
                        </div>
                    </div>
                    <div class="modal-body" v-if="step === 2">
                        <form-group help="You can find it in the Menu Tab, under Account Settings">
                            <form-input inputClass="form-control-lg" placeholder="Enter Device ID"
                                        v-model="add_hero.device_id" :v="$v.add_hero.device_id"/>
                        </form-group>
                        <div class="text-center my-2">OR</div>
                        <div class="d-flex align-items-start">
                            <div id="qr-code">
                                <qrcode-vue :size="187" v-if="add_hero.token" :value='add_hero.token'></qrcode-vue>
                            </div>
                            <div class="card">
                                <div class="card-body">
                                    <b>Scan the QR code with your device</b><br>
                                    You can also scan this QR code using the device you want to pair
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="divider --top-12"></div>
                <div class="d-flex flex-row justify-content-between gap-2" style="padding: 24px">
                    <btn class="btn-outline-light btn-lg flex-1" @click="stopTokenVerification(); step === 2 ? step = 1 : $modal.hide('addHeroModal')">Cancel</btn>
                    <btn class="btn-primary btn-lg flex-1"
                         v-if="step === 1"
                         :class="{'loading': loading.token }"
                         :disabled="!add_hero.name"
                         @click="getUserToken()">Next
                    </btn>
                    <btn class="btn-primary btn-lg flex-1"
                         v-if="step === 2"
                         :class="{'loading': loading.add }"
                         :disabled="!add_hero.device_id"
                         @click="addHero()">Add
                    </btn>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>

import HeroesTable from "@/components/HeroesTable.vue";
import HeroSelect from "@/components/HeroSelect.vue";
import QrcodeVue from 'qrcode.vue'
import ProfileImageUploader from "@/components/ProfileImageUploader.vue";
import ImageUploader from "@/components/ImageUploader.vue";
const {required, email} = require('vuelidate/lib/validators');

export default {
    name: 'Heroes',
    components: {ImageUploader, ProfileImageUploader, HeroSelect, HeroesTable,QrcodeVue},
    data() {
        return {
            loading: {
                add: false,
            },
            verifyInterval: null,
            add_hero: {
                device_id: null,
                name: '',
                profile_image: null,
                token: null,
            },
            step: 1,
        };
    },
    validations: {
        add_hero: {
            device_id: {required},
            name: {required},
        },
    },
    beforeDestroy() {
        this.stopTokenVerification();
    },
    methods: {
        addHero() {
            this.$v.add_hero.$touch();
            if (this.$v.add_hero.$invalid === true) {
                return false;
            }
            this.loading.add = true;
            this.$http.post("/hero/add", this.add_hero)
                .then((res) => {
                    this.$events.emit('loadHeroes');
                    this.loading.add = false;
                    this.stopTokenVerification();
                    this.$modal.hide('addHeroModal');
                })
                .catch((error) => {
                    this.loading.add = false;
                });
        },
        getUserToken() {
            this.$v.add_hero.name.$touch();
            if (this.$v.add_hero.name.$invalid === true) {
                return false;
            }

            this.loading.token = true;
            this.$http.post("/device/get-user-token", {
                action: "add_to_caregiver",
                meta: {
                    name: this.add_hero.name,
                    profile_image: this.add_hero.profile_image
                }
            })
                .then((res) => {
                    this.step = 2;
                    this.add_hero.token = res.body.data.token;
                    this.loading.token = false;
                    this.startTokenVerification();
                })
                .catch((error) => {
                    this.loading.token = false;
                });
        },
        startTokenVerification() {
            this.stopTokenVerification();
            this.verifyInterval = setInterval(() => {
                this.$http.post("/device/verify-user-token", {
                    token: this.add_hero.token
                })
                    .then((res) => {
                        if (res.body.data.used || res.body.data.expired) {
                            this.stopTokenVerification();
                            this.$modal.hide('addHeroModal');
                            this.$events.emit('loadHeroes');
                        }
                    })
                    .catch(() => {});
            }, 5000);
        },
        stopTokenVerification() {
            if (this.verifyInterval) {
                clearInterval(this.verifyInterval);
                this.verifyInterval = null;
            }
        },
        clearInput() {
            this.stopTokenVerification();
            this.add_hero.name = '';
            this.add_hero.device_id = '';
            this.add_hero.profile_image = null;
            this.add_hero.token = null;
            this.step = 1;
        }
    },
};
</script>
